// extracted by mini-css-extract-plugin
export default {"shareButton":"lh_p1","faceBookIcon":"Oh_3r","VKIcon":"FwRF2","telegramIcon":"lZn_X","whatsappIcon":"bFUGv"};